import { useLocaleStore, useT, type LocaleCode } from '@/i18n';
import { Globe } from 'lucide-react';

/**
 * v5.5 — Простой переключатель языков. Пока 2 опции (ru/en),
 * расширяется путём добавления locale-файлов в `i18n/translations/`.
 *
 * Используется в SettingsPage в новой секции "Язык".
 */
export default function LanguagePicker() {
  const locale = useLocaleStore((s) => s.locale);
  const setLocale = useLocaleStore((s) => s.setLocale);
  const t = useT();

  return (
    <section className="bg-surface-900 border border-surface-800 rounded-xl p-5">
      <h3 className="text-surface-100 font-semibold mb-1 flex items-center gap-2">
        <Globe size={16} className="text-brand-400" />
        {t('settings.sections.language')}
      </h3>
      <p className="text-xs text-surface-500 mb-4">
        {locale === 'ru'
          ? 'Часть интерфейса уже переведена; остальные строки — постепенно.'
          : 'Part of the UI is translated; the rest will follow.'}
      </p>
      <div className="grid grid-cols-2 gap-2">
        {(['ru', 'en'] as LocaleCode[]).map((code) => {
          const selected = locale === code;
          return (
            <button
              key={code}
              type="button"
              onClick={() => setLocale(code)}
              className={`px-3 py-2 rounded-lg text-sm font-medium border transition-colors ${
                selected
                  ? 'bg-brand-600/20 text-brand-300 border-brand-500'
                  : 'bg-surface-800 text-surface-300 border-surface-700 hover:border-surface-600'
              }`}
            >
              {t(`settings.language.${code}`)}
            </button>
          );
        })}
      </div>
    </section>
  );
}
